module.exports = __webpack_public_path__ + "img/rate-img3.dd040c0d.png";